import dayjs from 'dayjs';
import { FormModel } from '../../../../../../components/Form';
import { Validators } from '../../../../../../utils/validators';

export const unavailabilityDateForm = (strings: any): FormModel[] => {
  const today = dayjs(new Date());
  return [
    {
      label: strings.venueConfig_general_unavailabilityStart,
      value: '',
      size: 'medium',
      autoFocus: true,
      type: 'date',
      typeValue: 'text',
      variant: 'outlined',
      placeholder: '',
      field: 'unavailabilityStartDate',
      validators: [{ check: Validators.validateMandatoryField }],
      responsive: { xs: 12 },
      required: true,
      minDate: today,
    },
    {
      label: strings.venueConfig_general_unavailabilityEnd,
      value: '',
      size: 'medium',
      autoFocus: false,
      type: 'date',
      typeValue: 'text',
      variant: 'outlined',
      placeholder: '',
      field: 'unavailabilityEndDate',
      validators: [{ check: Validators.validateMandatoryField }],
      responsive: { xs: 12 },
      required: true,
      minDate: today,
    },
  ];
};
